import { render, staticRenderFns } from "./ReportInventory.vue?vue&type=template&id=6679fddc"
import script from "./ReportInventory.vue?vue&type=script&lang=js"
export * from "./ReportInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports